import { useContext, useEffect, useState } from 'react'
import './AdvancedSearchForm.css';
import { country_options } from '../data/countries';
import { UserSearchQuery } from '../interfaces/UserInterfaces';
import { AdminContext } from '../contexts/AdminContext';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Grid from '@mui/material/Unstable_Grid2';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { COSMOS_API, POST_ENDPOINT } from '../api/API';
import useAccessToken from '../hooks/accessToken';
import { useSnackbar } from 'notistack';
import PopUp from './PopUp';
import Dialog from '@mui/material/Dialog/Dialog';
import DialogTitle from '@mui/material/DialogTitle/DialogTitle';
import DialogContent from '@mui/material/DialogContent/DialogContent';
import DialogContentText from '@mui/material/DialogContentText/DialogContentText';
import DialogActions from '@mui/material/DialogActions/DialogActions';

interface AdvancedSearchFormProps {
    resetSearch: () => void,
    searchQuery: UserSearchQuery,
    newQuery: (newParams: UserSearchQuery) => void,
    countOffset: [number, number]
}

const AdvancedSearchForm = (props: AdvancedSearchFormProps) => {
    const {adminCredentials} = useContext(AdminContext);
    const { getToken } = useAccessToken();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [showScimDelete, setShowScimDelete] = useState<boolean>(false);
    const [scimUsersDeleteInProgress, setScimUsersDeleteInProgress] = useState<boolean>(false);
    const [searchForm, setSearchForm] = useState<UserSearchQuery>(props.searchQuery);
    const dropdownStarter = [{id: '', label: 'Select one'}]
    const allOrgs = dropdownStarter.concat(adminCredentials.organizationList.map(org => {return { id: org.id, label: org.name }}).sort((a, b) => a.label <= b.label ? -1 : 1));
    const allApps = dropdownStarter.concat(Object.keys(adminCredentials.allApplications).map(appKey => {return { id: appKey, label: adminCredentials.allApplications[appKey]?.name }}).sort((a, b) => a.label <= b.label ? -1 : 1));
    const [searchableApplications, setSearchableApplications] = useState<Array<{id: string, label: string}>>(allApps);

    useEffect(() => {
        if(searchForm.organizationId !== ''){
            let org = adminCredentials.organizationList.find(org => org.id === searchForm.organizationId);
            if(org !== undefined){
                let orgAppList = org.apps.map(appKey => { return { id: appKey, label: adminCredentials.allApplications[appKey]?.name } })?.sort((a, b) => a.label <= b.label ? -1 : 1);
                let globalAppList = Object.keys(adminCredentials.allApplications).filter(appKey => adminCredentials.allApplications[appKey].isGlobal).map(appKey => { return { id: appKey, label: adminCredentials.allApplications[appKey].name } });
                let includedAppList = orgAppList.concat(globalAppList);
                setSearchableApplications(dropdownStarter.concat(includedAppList));
                if(includedAppList.some(includedApp => includedApp.id == searchForm.applicationId) === false)
                    setSearchForm({...searchForm, applicationId: '', userProvisionStatus: ''});
            } else {
                let globalAppList = Object.keys(adminCredentials.allApplications).filter(appKey => adminCredentials.allApplications[appKey].isGlobal).map(appKey => { return { id: appKey, label: adminCredentials.allApplications[appKey].name } });
                setSearchableApplications(dropdownStarter.concat(globalAppList));
                if (globalAppList.some(includedApp => includedApp.id == searchForm.applicationId) === false)
                    setSearchForm({...searchForm, applicationId: '', userProvisionStatus: ''});
            }
        }
        else{
            setSearchableApplications(allApps);
        }
    }, [searchForm.organizationId])

    const handleNewSearch = (e: any) => {
        e.preventDefault();
        props.newQuery(searchForm);
    }
    const clearUIFields = (e: any) => {
        e.preventDefault();
        searchForm.email = "";
        searchForm.country = "";
        searchForm.firstName = "";
        searchForm.lastName = "";
        searchForm.organizationId = "";
        searchForm.applicationId = "";
        searchForm.userProvisionStatus = "";
    }

    const disableSearch = (): boolean => {
        if(searchForm.country !== 'all')
            return false;
        if(searchForm.email !== '')
            return false;
        if(searchForm.firstName !== '')
            return false;
        if(searchForm.lastName !== '')
            return false;
        if(searchForm.organizationId !== '')
            return false;
        if(searchForm.applicationId !== '')
            return false;
        return true;
    }

    const handleDeleteScimOrg = (e: any) => {
        e.preventDefault();
        setShowScimDelete(true);
    }
    const isScimOrg = (orgId: string): boolean => {
        let org = adminCredentials.organizationList.find(org => org.id === orgId);
        if(org !== undefined && org.isScimOrg === true)
            return true;
        return false;
    }

    
    const approveDelete = (approve: boolean) => {
    setShowScimDelete(false);
    if(approve){
        setScimUsersDeleteInProgress(true);
        COSMOS_API.POST(
            {
                "orgId": searchForm.organizationId,
                "deleteFromB2C": "true"
            },
            POST_ENDPOINT.DeleteAllOrgUsersAdmin,
            getToken()
        ).then((resp) => {

            setScimUsersDeleteInProgress(false);
            if(resp.ok){
                enqueueSnackbar("Successfully deleted all users from the organization", { variant: "success" });
            }else{
                console.log(resp);
                enqueueSnackbar("Error " + resp.status + " : Failed to delete users from the organization ", { variant: "error" });
            }
        }).finally(() => {
            setScimUsersDeleteInProgress(false);
        })
    }}

    return (
        <div>
            <div >
            <nav className="sub">
        <Typography variant="h5">
            Search Users
            </Typography>
            </nav>
                <Grid container flexDirection={"row"} spacing={2} sx={{marginBlock: '10px'}}>
                    <Grid container direction={"column"} xs={6}>
                           <Grid >
                               < TextField
                                label="Email Address"
                                    name="email"
                                    className="filter-input"
                                    value={searchForm.email}
                                    onChange={e => setSearchForm({...searchForm, email: e.target.value})}
                                    fullWidth
                                    size='small'
                                />
                           </Grid>
                            <Grid >
                                < TextField
                                label="First Name"
                                    name="firstName"
                                    placeholder="Search first name"
                                    className="filter-input"
                                    value={searchForm.firstName}
                                    onChange={e => setSearchForm({...searchForm, firstName: e.target.value})}
                                    fullWidth
                                    size='small'
                                />
                            </Grid>
                            <Grid >
                                < TextField
                                label="Last Name"
                                    name="lastName"
                                    placeholder="Search Lastname"
                                    className="filter-input"
                                    value={searchForm.lastName}
                                    onChange={e => setSearchForm({...searchForm, lastName: e.target.value})}
                                    fullWidth
                                    size='small'
                                />
                            </Grid>
                            <Grid >
                                <Autocomplete
                                    disablePortal
                                    sx={{backgroundColor: "white"}}
                                    value={searchForm.country !== undefined && searchForm.country !== null && searchForm.country !== '' && searchForm.country !== 'all' ? country_options.find(option => option.value === searchForm.country) : {value: "all", label: "All Countries"}}
                                    options={[{value: "all", label: "All Countries"},...country_options]}
                                    isOptionEqualToValue={(option, value) => value === undefined && option.value === 'all' ? true : value.value === option.value}
                                    renderInput={(params) => <TextField {...params} label="Country" />}
                                    onChange={(event: any, value: {value: string, label: string} | null) => {
                                        value !== undefined && value !== null ? setSearchForm({...searchForm, country: value.value}) : setSearchForm({...searchForm, country: "all"}) }}
                                    fullWidth
                                    size='small'
                                />
                            </Grid>
                        </Grid>
                        <Grid container direction={"column"} xs={6}>
                            <Grid sx={{display: (adminCredentials.isSuperAdmin || adminCredentials.multiOrg) ? 'inherit' : 'none'}}>
                                {(adminCredentials.isSuperAdmin || adminCredentials.multiOrg) && <Autocomplete
                                    id="organization-search"                            
                                    disablePortal
                                    disableClearable
                                    sx={{backgroundColor: "white"}}
                                    value={allOrgs.find(org => org.id === searchForm.organizationId) ?? dropdownStarter[0]}
                                    options={allOrgs}
                                    renderInput={(params) => <TextField {...params} label="Organization" />}
                                    onChange={(e: any, newValue) => {
                                        newValue ? setSearchForm({...searchForm, organizationId: newValue.id}) : null ;
                                    }
                                    }
                                    fullWidth
                                    size='small'
                                />}
                            </Grid>
                            <Grid>
                                <Autocomplete
                                    id="application-search"                            
                                    disablePortal
                                    disableClearable
                                    sx={{backgroundColor: "white", display: searchForm.organizationId === undefined || searchForm.organizationId === '' ? 'none' : 'inherit'}}
                                    value={searchableApplications.find(app => app.id === searchForm.applicationId) ?? dropdownStarter[0]}
                                    options={searchableApplications}
                                    renderInput={(params) => <TextField {...params} label="Application" />}
                                    onChange={(e: any, newValue) => {
                                        newValue ? setSearchForm({...searchForm, applicationId: newValue.id}) : null ;
                                    }
                                    }
                                    fullWidth
                                    size='small'
                                />
                            </Grid>
                            <Grid>
                            <FormControl size='small' style={{ display: searchForm.organizationId === '' || searchForm.applicationId === '' ? 'none' : 'inherit' }}>
                                    <FormLabel>Application status:</FormLabel>
                                    <RadioGroup value={searchForm.userProvisionStatus} onChange={(e) => setSearchForm({...searchForm, userProvisionStatus: e.target.value })} row>
                                        <FormControlLabel control={<Radio size='small' />} value="" label="All"/>
                                        <FormControlLabel control={<Radio size='small' />} value="Approved" label="Approved"/>
                                        <FormControlLabel control={<Radio size='small' />} value="Pending" label="Pending"/>
                                        <FormControlLabel control={<Radio size='small' />} value="Rejected" label="Rejected"/>
                                    </RadioGroup>
                                </FormControl>
                                </Grid>
                        </Grid>
                </Grid>
                <Stack direction="row" spacing={2} justifyContent={'flex-end'} sx={{my: '10px'}}>
                    {searchForm.organizationId !== "" && isScimOrg(searchForm.organizationId) && !scimUsersDeleteInProgress 
                    && <Button variant='contained' onClick={handleDeleteScimOrg}>
                        Delete SCIM Organization Users
                    </Button>
                    }
                    <Button variant='contained' disabled={disableSearch()} onClick={handleNewSearch}>
                        Search
                    </Button>
                    <Button variant='outlined' onClick={(e)=>{
                        clearUIFields(e);
                        props.resetSearch();
                    }}>
                        Clear
                    </Button>
                </Stack>
                {scimUsersDeleteInProgress && <PopUp showCloseButton={false} msg="Deleting all users for the selected SCIM organization. This may take some time." setShowMsg={()=>{}} showMsg={scimUsersDeleteInProgress} msgStyling="info" />}
                
                <Dialog open={showScimDelete} onClose={setShowScimDelete} fullWidth maxWidth={'md'}>
                    <DialogTitle>Delete SCIM Organization Users</DialogTitle>
                    <DialogContent>
                            <DialogContentText>
                                Are you sure you want to delete all users for the selected SCIM organization? This action cannot be undone.
                            </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" onClick={() =>approveDelete(true)}>
                            Yes
                        </Button>
                        <Button variant="outlined" onClick={() =>approveDelete(false)}>
                            No
                        </Button>
                    </DialogActions>

                </Dialog>
            </div>
        </div>
    )
}

export default AdvancedSearchForm
